window.variantsChange = function () {
    const variantContainers = document.querySelectorAll('.card__information-size-variants');

    variantContainers.forEach(container => {
        if (container.dataset.variantsInitialized === 'true') return;

        const handle = container.getAttribute('data-handle');
        const colorList = container.querySelector('.list--card__information-color-variants');
        const sizeList = container.querySelector('.list--card__information-size-variants');

        if (!colorList && !sizeList) return;

        container.dataset.variantsInitialized = 'true';
        initializeVariants(container, handle);

        if (colorList) {
            colorList.addEventListener('click', function (event) {
                const clickedLi = event.target.closest('.card-variant-item');
                if (!clickedLi) return;

                const selectedColor = clickedLi.textContent.trim();
                updateActiveClass(colorList, clickedLi);
                updateSizeVariants(container, handle, selectedColor);

                const activeSizeItem = sizeList?.querySelector('.card-variant-item.active');
                if (activeSizeItem) {
                    const selectedSize = activeSizeItem.textContent.trim();
                    updateVariantId(container, handle, selectedColor, selectedSize);
                }

                const cardElement = clickedLi.closest('.card') || clickedLi.closest('.product-card-wrapper') || container.closest('.card');
                if (cardElement) {
                    const videoMetafield = cardElement.querySelector('.card__inner .card__media-video-metafield');
                    const imgElements = cardElement.querySelectorAll('.media.media--hover-effect > img, .shelf__image__wrapper img');

                    if (videoMetafield) {
                        videoMetafield.style.opacity = '0';
                    }
                    if (imgElements.length >= 2) {
                        const firstImg = imgElements[0];
                        const secondImg = imgElements[1];

                        firstImg.style.opacity = '0';
                        secondImg.style.opacity = '1';
                    }

                    const handleMouseOut = function () {
                        if (!cardElement.matches(':hover') && !(container && container.matches(':hover'))) {
                            if (videoMetafield) videoMetafield.style.opacity = '1';
                            if (imgElements.length >= 2) {
                                imgElements[0].removeAttribute('style');
                                imgElements[1].removeAttribute('style');
                            }
                        }
                    };

                    cardElement.addEventListener('mouseout', handleMouseOut);
                    if (container) container.addEventListener('mouseout', handleMouseOut);
                }

                const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index' || document.body.classList.contains('template-index');
                const currentViewMode = isHomePage ? 'itemView' : (sessionStorage.getItem('viewMode') || 'modelView');

                if (currentViewMode === 'itemView') {
                    updatePhotoCard(container, clickedLi);
                }
                if (currentViewMode === 'modelView') {
                    updateModelImages(container, clickedLi, selectedColor);
                }

                updatePrices(container);
            });
        }

        if (sizeList) {
            sizeList.addEventListener('click', function (event) {
                if (event.target.classList.contains('card-variant-item')) {
                    const selectedSize = event.target.textContent.trim();
                    updateActiveClass(sizeList, event.target);

                    const activeColorItem = colorList?.querySelector('.card-variant-item.active');
                    if (activeColorItem) {
                        const selectedColor = activeColorItem.textContent.trim();
                        updateVariantId(container, handle, selectedColor, selectedSize);
                    }

                    updatePrices(container);
                }
            });
        }
    });

    function getCardAddElements(container) {
        const cardRoot = container.parentNode || container.closest('.card__content-variant');
        if (!cardRoot) return {};

        return {
            variantInput: cardRoot.querySelector('.add__card-tocart'),
            submitButton: cardRoot.querySelector('product-form.add-card-form [type="submit"]') || cardRoot.querySelector('product-form.add-card-form button')
        };
    }

    function initializeVariants(container, handle) {
        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(product => {
                const variants = product.variants;
                const firstAvailableVariant = variants.find(variant => variant.available);

                if (firstAvailableVariant) {
                    const initialColor = firstAvailableVariant.option1;
                    const initialSize = firstAvailableVariant.option2;

                    const colorList = container.querySelector('.list--card__information-color-variants');
                    const sizeList = container.querySelector('.list--card__information-size-variants');

                    const initialColorItem = Array.from(colorList.querySelectorAll('.card-variant-item'))
                        .find(item => item.textContent.trim() === initialColor);
                    const initialSizeItem = Array.from(sizeList.querySelectorAll('.card-variant-item'))
                        .find(item => item.textContent.trim() === initialSize);

                    if (initialColorItem) {
                        updateActiveClass(colorList, initialColorItem);
                    }

                    if (initialSizeItem) {
                        updateActiveClass(sizeList, initialSizeItem);
                    }

                    container.setAttribute('data-variant-id', firstAvailableVariant.id);

                    updateSizeVariants(container, handle, initialColor);
                }
            });
    }

    function updateVariantId(container, handle, color, size) {
        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(product => {
                const variants = product.variants;
                const selectedVariant = variants.find(variant => variant.option1 === color && variant.option2 === size);

                if (selectedVariant && selectedVariant.available) {
                    container.setAttribute('data-variant-id', selectedVariant.id);
                    const { variantInput, submitButton } = getCardAddElements(container);
                    if (variantInput) variantInput.setAttribute('value', selectedVariant.id);
                    if (submitButton) submitButton.removeAttribute('disabled');

                    const cardWrapper = container.closest('.card-wrapper');

                    // update links with var links a.prodLink
                    const links = cardWrapper.querySelectorAll('a.prodLink');

                    links.forEach(link => {
                        const url = new URL(link.href);
                        const params = new URLSearchParams(url.search);

                        if (params.has('variant')) {
                            params.set('variant', selectedVariant.id);
                        } else {
                            params.append('variant', selectedVariant.id);
                        }

                        url.search = params.toString();
                        link.href = url.toString();
                    });

                } else {
                    const { submitButton } = getCardAddElements(container);
                    if (submitButton) submitButton.setAttribute('disabled', 'disabled');
                }
            });
    }

    function updatePhotoCard(container, liElement) {
        if (!liElement) return;

        // Detectar se estamos na home e forçar itemView
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index' || document.body.classList.contains('template-index');
        const currentViewMode = isHomePage ? 'itemView' : (sessionStorage.getItem('viewMode') || 'modelView');
        if (currentViewMode !== 'itemView') return;

        // Obter a imagem da variante selecionada
        let newImageSrc = liElement.dataset.img || liElement.getAttribute('data-img') || '';

        if (!newImageSrc || newImageSrc === '/cdn/shop/' || newImageSrc.trim() === '') {
            console.log('Imagem da variante inválida, tentando fallback...');
            // Fallback: buscar imagem da variante via API
            const handle = container.getAttribute('data-handle');
            const selectedColor = liElement.textContent.trim();

            fetch(`/products/${handle}.js`)
                .then(response => response.json())
                .then(product => {
                    const variant = product.variants.find(v => v.option1 === selectedColor);
                    if (variant && variant.featured_image) {
                        newImageSrc = variant.featured_image;
                        updateImagesInItemView(container, liElement, newImageSrc);
                    } else {
                        console.error('Variante não encontrada ou sem imagem');
                    }
                })
                .catch(error => {
                    console.error('Erro ao buscar variante:', error);
                });
            return;
        }

        // Processar URL da imagem
        if (newImageSrc.startsWith('//')) {
            newImageSrc = window.location.protocol + newImageSrc;
        } else if (newImageSrc.startsWith('/')) {
            newImageSrc = window.location.origin + newImageSrc;
        }

        updateImagesInItemView(container, liElement, newImageSrc);
    }

    function updateImagesInItemView(container, liElement, imageSrc) {
        const cardElement = liElement.closest('.card') || liElement.closest('.product-card-wrapper') || container.closest('.card');
        if (!cardElement) {
            console.error('Card element não encontrado');
            return;
        }

        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        if (imageWrapper) {
            imageWrapper.dataset.imageIndex = '0';
        }

        // No itemView, queremos mostrar APENAS a imagem do produto (sem modelo)
        // Procurar por imagens que são especificamente do produto
        const productImages = cardElement.querySelectorAll('img.modelview, .shelf__image__wrapper img.modelview');

        productImages.forEach(img => {
            img.src = imageSrc;
            img.srcset = `${imageSrc} 165w, ${imageSrc} 360w, ${imageSrc} 533w`;
        });

        const selectedColor = liElement.textContent.trim();
        updateHoverImageForColor(cardElement, selectedColor);
    }

    function updateModelImages(container, liElement, selectedColor) {
        if (!liElement) return;

        const currentViewMode = sessionStorage.getItem('viewMode') || 'modelView';
        if (currentViewMode !== 'modelView') {
            return;
        }

        const cardElement = liElement.closest('.card') || liElement.closest('.product-card-wrapper') || container.closest('.card');
        if (!cardElement) {
            return;
        }

        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        if (!imageWrapper) {
            return;
        }

    try {
        const colorImagesData = imageWrapper.getAttribute('color-images');
        
        if (!colorImagesData || colorImagesData === '') {
            applyModelViewFallback(cardElement, liElement);
            return;
        }

            try {
                // Limpar possíveis caracteres HTML entities
                const cleanData = colorImagesData.replace(/&quot;/g, '"').replace(/&amp;/g, '&');
                const colorToImagesMap = JSON.parse(cleanData);

                // Buscar as imagens da cor selecionada
                const selectedColorImages = colorToImagesMap[selectedColor];

            if (!selectedColorImages || !Array.isArray(selectedColorImages) || selectedColorImages.length === 0) {
                applyModelViewFallback(cardElement, liElement);
                return;
            }

                const modelImage1 = selectedColorImages[0];
                const modelImage2 = getHoverImageForColor(cardElement, selectedColor);

            if (!modelImage1) {
                applyModelViewFallback(cardElement, liElement);
                return;
            }

                updateImagesInModelView(cardElement, modelImage1, modelImage2);

        } catch (error) {
            console.error('Erro ao processar imagens do produto:', error);
            applyModelViewFallback(cardElement, liElement);
        }

    } catch (error) {
        console.error('Erro geral ao processar imagens do produto:', error);
        applyModelViewFallback(cardElement, liElement);
    }
}

    function parseColorHoverImagesMap(imageWrapper) {
        if (!imageWrapper) return null;

        const colorHoverImagesData = imageWrapper.getAttribute('color-hover-images');
        if (!colorHoverImagesData || colorHoverImagesData === '{}') {
            return null;
        }

        try {
            const cleanData = colorHoverImagesData.replace(/&quot;/g, '"').replace(/&amp;/g, '&');
            return JSON.parse(cleanData);
        } catch (error) {
            console.error('Erro ao processar imagens de hover:', error);
            return null;
        }
    }

    function getHoverImageForColor(cardElement, selectedColor) {
        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        if (!imageWrapper || imageWrapper.dataset.hoverIsVideo === 'true') {
            return null;
        }

        const colorHoverMap = parseColorHoverImagesMap(imageWrapper);
        if (colorHoverMap && selectedColor && colorHoverMap[selectedColor]) {
            return colorHoverMap[selectedColor];
        }

        const fallbackSecondary = imageWrapper.getAttribute('data-secondary');
        return fallbackSecondary ? normalizeImageUrl(fallbackSecondary) : null;
    }

    function updateHoverImageForColor(cardElement, selectedColor) {
        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        const hoverImages = cardElement.querySelectorAll('img.shelf__image--hover, .shelf__image__wrapper img.shelf__image--hover');
        const hoverUrl = getHoverImageForColor(cardElement, selectedColor);

        if (!hoverUrl || !hoverImages.length) {
            return;
        }

        hoverImages.forEach(img => {
            img.src = hoverUrl;
            img.srcset = `${hoverUrl} 165w, ${hoverUrl} 360w, ${hoverUrl} 533w`;
        });

        if (imageWrapper) {
            const pictures = imageWrapper.querySelectorAll('picture');
            setPictureSource(pictures[1], hoverUrl);
        }
    }

    function updateImagesInModelView(cardElement, modelImage1, modelImage2) {
        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        if (!imageWrapper || !modelImage1) return;

        const normalizedMainImage = normalizeImageUrl(modelImage1);
        const normalizedHoverImage = normalizeImageUrl(modelImage2 || modelImage1);

        imageWrapper.dataset.imageIndex = '0';
        imageWrapper.dataset.initialModelMain = normalizedMainImage;
        updateShelfImages(imageWrapper, normalizedMainImage, normalizedHoverImage);
    }

    function restoreModelViewMainImage(cardElement, imageWrapper, selectedColor) {
        const hoverImage = getHoverImageForColor(cardElement, selectedColor);
        const mainImage = imageWrapper.dataset.initialModelMain || getShelfLookbookImage(imageWrapper);

        if (!mainImage) return;

        imageWrapper.dataset.imageIndex = '0';
        updateShelfImages(imageWrapper, mainImage, hoverImage || mainImage);
    }

    function seedInitialModelViewMainImages() {
        document.querySelectorAll('.shelf__image__wrapper[data-image]').forEach(imageWrapper => {
            if (imageWrapper.dataset.initialModelMain) return;

            const mainImage = imageWrapper.querySelector('img.modelview');
            const mainUrl = mainImage
                ? normalizeImageUrl(mainImage.currentSrc || mainImage.src)
                : getShelfLookbookImage(imageWrapper);

            if (mainUrl) {
                imageWrapper.dataset.initialModelMain = mainUrl;
            }
        });
    }

    function updatePrices(container) {
        const productCardWrapper = container.closest('.product-card-wrapper');
        const dataType = container.getAttribute('data-type');

        const activeColorVariant = container.querySelector('.list--card__information-color-variants .card-variant-item.active');
        const activeSizeVariant = container.querySelector('.list--card__information-size-variants .card-variant-item.active');
        const color = activeColorVariant ? activeColorVariant.innerHTML.trim() : null;
        const size = activeSizeVariant ? activeSizeVariant.innerHTML.trim() : null;
        fetch(`/products/${container.getAttribute('data-handle')}.js`)
            .then(response => response.json())
            .then(product => {
                const variant = product.variants.find(v => {
                    const matchesColor = color ? v.option1 === color : true;
                    const matchesSize = size ? v.option2 === size : true;
                    return matchesColor && matchesSize;
                });

                if (variant) {
                    const outfitProd = productCardWrapper.querySelector(`.outfit_prod[data-type="${dataType}"]`);
                    const regularPriceElement = outfitProd.querySelector('.price-item--regular');
                    const salePriceElement = outfitProd.querySelector('.price-item--sale');

                    if (regularPriceElement) {
                        regularPriceElement.textContent = formatPrice(variant.compare_at_price);
                    }

                    if (salePriceElement) {
                        salePriceElement.textContent = formatPrice(variant.price);
                    }
                }
            });
    }



    function formatPrice(priceInCents) {
        if (!priceInCents) return '';

        const currencySymbol = window.Shopify?.currency?.symbol || 'R$';
        const formatMoney = window.Shopify?.currency?.formatPrice;

        if (formatMoney) {
            return `${currencySymbol} ${formatMoney(priceInCents)}`;
        }

        const priceValue = (priceInCents / 100).toFixed(2);
        const [integerPart, decimalPart] = priceValue.split('.');
        const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        return `${currencySymbol} ${formattedIntegerPart},${decimalPart}`;
    }

    function updateSizeVariants(container, handle, color) {
        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(product => {
                const variants = product.variants;
                const availableSizes = variants.filter(variant => variant.option1 === color);
                const sizeList = container.querySelector('.list--card__information-size-variants');

                sizeList?.querySelectorAll('.card-variant-item').forEach(item => {
                    const size = item.textContent.trim();
                    const sizeVariant = availableSizes.find(variant => variant.option2 === size);

                    if (sizeVariant) {
                        if (!sizeVariant.available) {
                            item.classList.add('card-variant-item-sold-out');
                        } else {
                            item.classList.remove('card-variant-item-sold-out');
                        }
                    }
                });

                const firstAvailableVariant = availableSizes.find(variant => variant.available);
                if (firstAvailableVariant) {
                    container.setAttribute('data-variant-id', firstAvailableVariant.id);
                    const { variantInput, submitButton } = getCardAddElements(container);
                    if (variantInput) variantInput.setAttribute('value', firstAvailableVariant.id);
                    if (submitButton) submitButton.removeAttribute('disabled');
                }

                updateColorVariants(container, handle, color);
            });
    }

    function updateColorVariants(container, handle, size) {
        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(product => {
                const variants = product.variants;
                const availableColors = variants.filter(variant => variant.option2 === size);
                const colorList = container.querySelector('.list--card__information-color-variants');

                colorList?.querySelectorAll('.card-variant-item').forEach(item => {
                    const color = item.textContent.trim();
                    const colorVariant = availableColors.find(variant => variant.option1 === color);

                    if (colorVariant) {
                        if (!colorVariant.available) {
                            item.classList.add('card-variant-item-sold-out');
                        } else {
                            item.classList.remove('card-variant-item-sold-out');
                        }
                    }
                });

                const activeSizeItem = container.querySelector('.list--card__information-size-variants .card-variant-item.active');
                const activeColorItem = container.querySelector('.list--card__information-color-variants .card-variant-item.active');
                if (!activeSizeItem || !activeColorItem) return;

                const selectedSize = activeSizeItem.textContent.trim();
                const selectedColor = activeColorItem.textContent.trim();

                const selectedVariant = variants.find(variant => variant.option1 === selectedColor && variant.option2 === selectedSize);

                if (selectedVariant && selectedVariant.available) {
                    container.setAttribute('data-variant-id', selectedVariant.id);
                    const { variantInput, submitButton } = getCardAddElements(container);
                    if (variantInput) variantInput.setAttribute('value', selectedVariant.id);
                    if (submitButton) submitButton.removeAttribute('disabled');

                } else {
                    const { submitButton } = getCardAddElements(container);
                    if (submitButton) submitButton.setAttribute('disabled', 'disabled');
                }

            });
    }

    function updateActiveClass(listElement, activeElement) {
        listElement.querySelectorAll('.card-variant-item').forEach(item => {
            item.classList.remove('active');
        });
        activeElement.classList.add('active');
    }

    function normalizeImageUrl(imageUrl) {
        if (!imageUrl) return '';
        if (imageUrl.startsWith('//')) return `${window.location.protocol}${imageUrl}`;
        if (imageUrl.startsWith('/')) return `${window.location.origin}${imageUrl}`;
        return imageUrl;
    }

    const CARD_IMAGE_WIDTHS = [400, 533, 720, 940, 1066];
    const CARD_IMAGE_MOBILE_WIDTHS = [300, 400, 600];

    function withShopifyImageWidth(url, width) {
        if (!url) return '';

        if (/[?&]width=\d+/.test(url)) {
            return url.replace(/([?&])width=\d+/, '$1width=' + width);
        }

        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function buildCardImageSrcset(url, widths) {
        return widths
            .map(function (width) {
                return withShopifyImageWidth(url, width) + ' ' + width + 'w';
            })
            .join(', ');
    }

    function getShelfLookbookImage(imageWrapper) {
        if (!imageWrapper) return null;
        const lookbookUrl = imageWrapper.getAttribute('data-image');
        return lookbookUrl ? normalizeImageUrl(lookbookUrl) : null;
    }

    function applyModelViewFallback(cardElement, liElement) {
        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        const lookbookImage = getShelfLookbookImage(imageWrapper);

        const activeColorItem = liElement || cardElement.querySelector('.list--card__information-color-variants .card-variant-item.active');
        const selectedColor = activeColorItem ? activeColorItem.textContent.trim() : null;
        const hoverImage = getHoverImageForColor(cardElement, selectedColor);

        if (lookbookImage) {
            updateImagesInModelView(cardElement, lookbookImage, hoverImage);
            return true;
        }

        const variantImage = liElement ? liElement.getAttribute('data-img') : null;
        if (!variantImage) return false;

        const normalizedVariantImage = normalizeImageUrl(variantImage);
        if (!normalizedVariantImage) return false;

        updateImagesInModelView(cardElement, normalizedVariantImage, hoverImage);
        return true;
    }

    function setImageElementSource(imageElement, imageUrl) {
        if (!imageElement || !imageUrl) return;
        const maxWidth = CARD_IMAGE_WIDTHS[CARD_IMAGE_WIDTHS.length - 1];
        imageElement.src = withShopifyImageWidth(imageUrl, maxWidth);
        imageElement.srcset = buildCardImageSrcset(imageUrl, CARD_IMAGE_WIDTHS);
    }

    function setPictureSource(pictureElement, imageUrl) {
        if (!pictureElement || !imageUrl) return;
        const source = pictureElement.querySelector('source');
        if (source) {
            source.srcset = buildCardImageSrcset(imageUrl, CARD_IMAGE_MOBILE_WIDTHS);
        }
    }

    function updateShelfImages(imageWrapper, currentImage, nextImage) {
        const normalizedCurrentImage = normalizeImageUrl(currentImage);
        const normalizedNextImage = normalizeImageUrl(nextImage || currentImage);
        const pictures = imageWrapper.querySelectorAll('picture');
        const mainImage = imageWrapper.querySelector('img.modelview');
        const hoverImage = imageWrapper.querySelector('img.shelf__image--hover');

        setPictureSource(pictures[0], normalizedCurrentImage);
        setImageElementSource(mainImage, normalizedCurrentImage);

        if (hoverImage) {
            setPictureSource(pictures[1], normalizedNextImage);
            setImageElementSource(hoverImage, normalizedNextImage);
        }
    }

    function getCurrentViewMode() {
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index' || document.body.classList.contains('template-index');
        return isHomePage ? 'itemView' : (sessionStorage.getItem('viewMode') || 'modelView');
    }

    function getImagesForActiveVariant(cardElement, options = {}) {
        const includeVariantStill = options.includeVariantStill === true;
        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        if (!imageWrapper) return [];

        const variantContainer = cardElement.querySelector('.card__information-size-variants');
        const activeColorItem = variantContainer
            ? variantContainer.querySelector('.list--card__information-color-variants .card-variant-item.active')
            : null;
        const selectedColor = activeColorItem ? activeColorItem.textContent.trim() : null;
        let variantImages = [];

        try {
            const colorImagesData = imageWrapper.getAttribute('color-images');
            if (colorImagesData) {
                const cleanData = colorImagesData.replace(/&quot;/g, '"').replace(/&amp;/g, '&');
                const colorToImagesMap = JSON.parse(cleanData);

                if (selectedColor && colorToImagesMap[selectedColor]) {
                    variantImages = colorToImagesMap[selectedColor];
                } else {
                    const availableColors = Object.keys(colorToImagesMap);
                    if (availableColors.length > 0) {
                        variantImages = colorToImagesMap[availableColors[0]] || [];
                    }
                }
            }
        } catch (error) {
            variantImages = [];
        }

        if (includeVariantStill && activeColorItem && activeColorItem.dataset.img) {
            variantImages = [activeColorItem.dataset.img, ...variantImages];
        }

        if (!variantImages.length) {
            const fallbackUrl = getCurrentViewMode() === 'itemView'
                ? imageWrapper.getAttribute('data-still')
                : imageWrapper.getAttribute('data-image');

            if (fallbackUrl) {
                variantImages = [fallbackUrl];
            } else {
                const imageElements = imageWrapper.querySelectorAll('img');
                variantImages = Array.from(imageElements).map(image => image.currentSrc || image.src);
            }
        }

        return [...new Set(variantImages.filter(Boolean))];
    }

    function resetShelfImagesForCurrentViewMode(cardElement, imageWrapper) {
        const currentViewMode = getCurrentViewMode();
        const variantContainer = cardElement.querySelector('.card__information-size-variants');
        const activeColorItem = variantContainer
            ? variantContainer.querySelector('.list--card__information-color-variants .card-variant-item.active')
            : null;
        const selectedColor = activeColorItem ? activeColorItem.textContent.trim() : null;
        const hoverImage = getHoverImageForColor(cardElement, selectedColor);

        if (currentViewMode === 'modelView') {
            const hadArrowNavigation = Number(imageWrapper.dataset.imageIndex || 0) !== 0;
            imageWrapper.dataset.imageIndex = '0';

            if (hadArrowNavigation) {
                restoreModelViewMainImage(cardElement, imageWrapper, selectedColor);
            }

            return;
        }

        imageWrapper.dataset.imageIndex = '0';

        if (activeColorItem && variantContainer) {
            updatePhotoCard(variantContainer, activeColorItem);
            return;
        }

        const stillUrl = imageWrapper.getAttribute('data-still') || imageWrapper.getAttribute('data-image');
        if (!stillUrl) return;

        const normalizedStillUrl = normalizeImageUrl(stillUrl);
        updateShelfImages(imageWrapper, normalizedStillUrl, hoverImage || normalizedStillUrl);
    }

    function handleShelfHoverEnter(event) {
        const wrapper = event.currentTarget;
        wrapper.classList.add('is-hover-active');

        const video = wrapper.querySelector('.shelf__video');
        if (video) {
            video.play().catch(() => {});
        }
    }

    function handleShelfHoverLeave(event) {
        const wrapper = event.currentTarget;
        wrapper.classList.remove('is-hover-active');

        const video = wrapper.querySelector('.shelf__video');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    }

    function handleCardImageResetLeave(event) {
        const cardInner = event.currentTarget;
        const cardElement = cardInner.closest('.card');
        if (event.relatedTarget && cardElement && cardElement.contains(event.relatedTarget)) return;

        const imageWrapper = cardInner.querySelector('.shelf__image__wrapper');
        if (!cardElement || !imageWrapper) return;

        resetShelfImagesForCurrentViewMode(cardElement, imageWrapper);
    }

    function initShelfHoverMedia() {
        document.querySelectorAll('.shelf__image__wrapper.has-hover-media').forEach(wrapper => {
            if (wrapper.dataset.shelfHoverInitialized === 'true') return;
            wrapper.dataset.shelfHoverInitialized = 'true';
            wrapper.addEventListener('mouseenter', handleShelfHoverEnter);
            wrapper.addEventListener('mouseleave', handleShelfHoverLeave);
        });
    }

    function initCardImageResetOnLeave() {
        document.querySelectorAll('.card .card__inner').forEach(cardInner => {
            if (!cardInner.querySelector('.shelf__image__wrapper')) return;
            if (cardInner.dataset.cardImageResetInitialized === 'true') return;
            cardInner.dataset.cardImageResetInitialized = 'true';
            cardInner.addEventListener('mouseleave', handleCardImageResetLeave);
        });
    }

    function initSecondaryImageHover() {
        initShelfHoverMedia();
        initCardImageResetOnLeave();
    }

    function handleProductCardImageArrow(event) {
        event.preventDefault();
        event.stopPropagation();

        const button = event.currentTarget;
        const cardElement = button.closest('.card');
        if (!cardElement) return;

        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        if (!imageWrapper) return;

        const variantImages = getImagesForActiveVariant(cardElement);
        if (variantImages.length <= 1) return;

        const variantContainer = cardElement.querySelector('.card__information-size-variants');
        const activeColorItem = variantContainer
            ? variantContainer.querySelector('.list--card__information-color-variants .card-variant-item.active')
            : null;
        const selectedColor = activeColorItem ? activeColorItem.textContent.trim() : null;
        const hoverImage = getHoverImageForColor(cardElement, selectedColor);

        const direction = button.dataset.productCardImageArrow === 'prev' ? -1 : 1;
        const currentIndex = Number(imageWrapper.dataset.imageIndex || 0);
        const nextIndex = (currentIndex + direction + variantImages.length) % variantImages.length;

        imageWrapper.dataset.imageIndex = String(nextIndex);
        updateShelfImages(imageWrapper, variantImages[nextIndex], hoverImage || variantImages[nextIndex]);
    }

    // Função para resetar as imagens para o estado inicial baseado no viewMode
    function resetImagesToInitialState(container, forcedViewMode = null) {
        // Detectar se estamos na home e forçar itemView
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index' || document.body.classList.contains('template-index');
        const currentViewMode = forcedViewMode || (isHomePage ? 'itemView' : (sessionStorage.getItem('viewMode') || 'modelView'));
        
        const cardElement = container.closest('.card') || container.closest('.product-card-wrapper');

        if (!cardElement) return;

        const imageWrapper = cardElement.querySelector('.shelf__image__wrapper');
        if (!imageWrapper) return;

        if (currentViewMode === 'itemView') {
            // No itemView, resetar para a imagem da variante ativa
            const activeColorItem = container.querySelector('.list--card__information-color-variants .card-variant-item.active');
            if (activeColorItem) {
                const selectedColor = activeColorItem.textContent.trim();
                updatePhotoCard(container, activeColorItem);
            }
        } else if (currentViewMode === 'modelView') {
            // No modelView, resetar para as imagens da modelo da cor ativa
            const activeColorItem = container.querySelector('.list--card__information-color-variants .card-variant-item.active');
            if (activeColorItem) {
                const selectedColor = activeColorItem.textContent.trim();
                updateModelImages(container, activeColorItem, selectedColor);
            }
        }
    }

    // Função para inicializar as imagens corretas baseado no viewMode atual
    function initializeImagesForCurrentViewMode() {
        const colletionContainers = document.querySelectorAll('.container__collection-section');
        // Detectar se estamos na home ou template da seção definida como still e forçar itemView
        colletionContainers.forEach(container => {
            const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index' || document.body.classList.contains('template-index') || container.classList.contains('template--still');
            const currentViewMode = isHomePage ? 'itemView' : (sessionStorage.getItem('viewMode') || 'modelView');
            const variantContainers = container.querySelectorAll('.card__information-size-variants');
            variantContainers.forEach(variantContainer => {
                resetImagesToInitialState(variantContainer, currentViewMode);
            });
        });
    }

    // Adicionar função ao escopo global para ser acessível pelo collections.js
    window.initializeImagesForCurrentViewMode = initializeImagesForCurrentViewMode;

    // Função de debug para verificar o estado atual das imagens
    function debugCurrentImageState(container) {
        const currentViewMode = sessionStorage.getItem('viewMode') || 'modelView';
        const cardElement = container.closest('.card') || container.closest('.product-card-wrapper');

        if (!cardElement) return;

        const modelImages = cardElement.querySelectorAll('img.modelview, .shelf__image__wrapper img.modelview');
        const hoverImages = cardElement.querySelectorAll('img.shelf__image--hover, .shelf__image__wrapper img.shelf__image--hover');

        console.log('=== DEBUG: Estado atual das imagens ===');
        console.log('ViewMode:', currentViewMode);
        console.log('Imagens principais encontradas:', modelImages.length);
        console.log('Imagens hover encontradas:', hoverImages.length);

        modelImages.forEach((img, index) => {
            console.log(`Imagem principal ${index + 1}:`, img.src);
        });

        hoverImages.forEach((img, index) => {
            console.log(`Imagem hover ${index + 1}:`, img.src);
        });
        console.log('=== FIM DEBUG ===');
    }

    // Adicionar função ao escopo global para debug
    window.debugCurrentImageState = debugCurrentImageState;

    function initProductCardImageArrows() {
        document.querySelectorAll('[data-product-card-image-arrow]').forEach(button => {
            if (button.dataset.imageArrowInitialized === 'true') return;
            const cardElement = button.closest('.card');
            if (cardElement) {
                cardElement.classList.add('has-product-card-image-arrows');
            }
            button.dataset.imageArrowInitialized = 'true';
            button.addEventListener('click', handleProductCardImageArrow);
        });
    }

    window.initProductCardImageArrows = initProductCardImageArrows;
    window.initSecondaryImageHover = initSecondaryImageHover;

    document.querySelectorAll('.outfit-icons .top, .outfit-icons .bottom').forEach(function (icon) {
        icon.addEventListener('click', function (event) {
            event.preventDefault();
            const parentWrapper = this.closest('.product-card-wrapper');
            const type = this.classList.contains('top') ? 'top' : 'bottom';
            if (!parentWrapper) return;

            parentWrapper.querySelectorAll('[data-typeprod]').forEach(productWrapper => {
                productWrapper.style.display = productWrapper.dataset.typeprod === type ? 'block' : 'none';
            });

            parentWrapper.querySelectorAll('.outfit_prod').forEach(productInfo => {
                productInfo.classList.toggle('active', productInfo.dataset.type === type);
            });
        });
    });

    initProductCardImageArrows();
    initSecondaryImageHover();
    seedInitialModelViewMainImages();


    //loading card add
    document.querySelectorAll('.quick-add__submit').forEach(button => {
        button.addEventListener('click', function () {
            this.classList.add('loading');
            setTimeout(() => {
                this.classList.remove('loading');
            }, 2000);
        });
    });
}

window.priceFromDolar = function () {
    if (location.href.endsWith('/en') || location.href.includes('/en/')) {
        document.querySelectorAll('.outfit_prod-price').forEach(function (salePriceElement) {
            if (!salePriceElement.querySelector('.from')) {
                let fromSpan = document.createElement('span');
                fromSpan.className = 'from';
                fromSpan.textContent = 'from ';
                salePriceElement.insertBefore(fromSpan, salePriceElement.firstChild);
            }
        });
    }
};


function initializeCardProductScripts() {
    try {
        window.variantsChange();
    } catch (error) {
        console.error(error);
    }

    window.priceFromDolar();

    // Inicializar imagens para o viewMode atual após um pequeno delay
    setTimeout(() => {
        if (window.initializeImagesForCurrentViewMode) {
            window.initializeImagesForCurrentViewMode();
        }
    }, 200);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCardProductScripts);
} else {
    initializeCardProductScripts();
}
